// 新規: 商品グループタイプ取得APIクライアント
import { apiGet } from './client';
import type { ProductGroupLevelCounts, ProductGroupType } from '@/lib/types';

// 後方互換性のため、型を再エクスポート
export type { ProductGroupLevelCounts, ProductGroupType } from '@/lib/types';

export async function getProductGroupTypes(
  accountId: string,
  authHeaders?: Record<string, string>,
): Promise<ProductGroupType[]> {
  // accountIdはバックエンドのルーティングに合わせて付与
  return apiGet<ProductGroupType[]>(`/${accountId}/product-group-types`, authHeaders);
}

/**
 * 集計階層別の商品グループ数を取得する（FKV3-12586）
 *
 * 掛け合わせ抽出で「選んだ組み合わせが何通りになるか」を実行前に見積もるために使う。
 * 商品グループマスタだけを読む軽いクエリなので、掛け合わせを選んだときに遅延取得する。
 */
export async function getProductGroupLevelCounts(
  accountId: string,
  authHeaders?: Record<string, string>,
): Promise<ProductGroupLevelCounts[]> {
  return apiGet<ProductGroupLevelCounts[]>(
    `/${accountId}/product-group-types/depth-counts`,
    authHeaders,
  );
}
